import type { ThemeComponentType } from '../types';

export const Skeleton: ThemeComponentType = {
  styles: theme => ({
    root: {
      '&:after': {
        backgroundColor: `${theme.colors.gray[1]} !important`,
      },
    },
  }),
};
